import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { TrailerOperationRequest } from 'src/app/model/cms-vod-core/trailer-operation.model';
import { UtilityModel } from 'src/app/model/utility-models/utility.model';
import { CastControllerService } from 'src/app/services/cast-controller/cast-controller.service';
import { ProgramService } from 'src/app/services/cms-btv-core/program-controller/program.service';
import { CatchupRequestService } from 'src/app/services/cms-vod-core/catchup-request-controller/catchup-request.service';
import { CatchupService } from 'src/app/services/cms-vod-core/catchup-service/catchup.service';
import { ContentIssueTypeService } from 'src/app/services/cms-vod-core/content-issues-type/content-issue-type.service';
import { ContentLanguageMetadataService } from 'src/app/services/cms-vod-core/content-language-metadata-controller/content-language-metadata.service';
import { ContentService } from 'src/app/services/cms-vod-core/contents-controller/content.service';
import { EncodingProfilesService } from 'src/app/services/cms-vod-core/encoding-profiles-controller/encoding-profiles.service';
import { LicenseService } from 'src/app/services/cms-vod-core/license-controller/license.service';
import { PlanningService } from 'src/app/services/cms-vod-core/planning/planning.service';
import * as RefreshActions from 'src/app/utility/actions/refresh-state.actions';
import { Utility } from 'src/app/utility/utility';
import { ContentMediaFilesRequest } from '../../model/content-media-file-request.model';
import { FilterPresetDataService } from '../../services/filter-preset-data-controller/filter-preset-data.service';
import { DataSharingService } from '../data-sharing.service';
import { PackagePresetP } from 'src/app/model/encoder-manager/package-preset.model';
import { PackageProfilesService } from 'src/app/services/cms-vod-core/encoding-profiles-controller/package-profiles.service';
import {
  TranscodePresetsService
} from 'src/app/services/cms-vod-core/encoding-profiles-controller/transcode-profiles.service';
import { RefreshManagerService, RefreshTarget } from '../RefreshManagerService';
import { AlertService } from '../alert.service';
@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.css'],
})
export class AlertModalComponent implements OnInit, AfterViewInit, OnDestroy {
  loading: boolean = false;
  utilityModel: UtilityModel;
  catchupRequestId: number;
  subscription: Subscription;
  timer: any;
  constructor(
    private transcodePresetsService: TranscodePresetsService,
    private metadatLanguageService: ContentLanguageMetadataService,
    private programService: ProgramService,
    private contentIssueTypeService: ContentIssueTypeService,
    private encodingProfileService: EncodingProfilesService,
    private catchupRequestService: CatchupRequestService,
    private filterPresetDataService: FilterPresetDataService,
    private dataSharingService: DataSharingService,
    private refreshManager: RefreshManagerService,
    private castService: CastControllerService,
    private planningService: PlanningService,
    private catchupService: CatchupService,
    private contentService: ContentService,
    private licenseService: LicenseService,
    private packagePresetService: PackageProfilesService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private utility: Utility,
    private store: Store<AppState>,
  ) {
    this.subscription = this.dataSharingService.getUtilityModel().subscribe((response) => {
      this.utilityModel = response;
    });
  }

  ngOnInit(): void {
    this.utility.closeModalOnAnyWhere('alert-modal');
  }

  ngAfterViewInit(): void {
    this.utility.openModal('alert-modal');
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    clearTimeout(this.timer);
    this.store.dispatch(new RefreshActions.ResetState());
  }

  //Delete Requested Catchup Content
  deleteCatchupRequestContent(seriesId: string): void {
    this.loading = true;

    try {
      this.catchupRequestService.deleteCatchupRequest(seriesId).subscribe((_) => {
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_REQUEST_LIST);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_EXTENDED_LIST);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUPS);
        this.refreshManager.sendRefresh(RefreshTarget.TRIM_PLAYER);
        this.message();
      });
    } catch (error) {
      this.loading = true;
    }
  }

  // epgExternalId, EPG programinin UUID'si (Program.externalId). Metadata.epgProgramId
  // saglayicinin string id'sidir ve /programs/{id} ucuna gonderilirse UUID'ye cevrilemez.
  setAsCutvEnabled(epgExternalId: string): void {
    this.programService.getProgramById(epgExternalId).subscribe(
      (response) => {
        response.cutvEnabled = false;
        this.programService.updateProgram(response).subscribe((_) => {
          this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_REQUEST_LIST);
          this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_EXTENDED_LIST);
          this.refreshManager.sendRefresh(RefreshTarget.CATCHUPS);
          this.refreshManager.sendRefresh(RefreshTarget.TRIM_PLAYER);
        });
      },
      // Catchup silindi; program EPG temizligiyle gitmis olabilir. Bu ikincil
      // guncelleme silme sonucunu etkilemesin.
      () => {},
    );
  }

  //Delete catchup
  deleteCatchupContent(catchupId: number, epgExternalId: string): void {
    this.loading = true;
    this.catchupService.deleteCatchup(catchupId).subscribe(
      () => {
        if (epgExternalId) {
          this.setAsCutvEnabled(epgExternalId);
        }
        this.message();
        this.catchupService.notifyCatchupDeleted();
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_REQUEST_LIST);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUP_EXTENDED_LIST);
        this.refreshManager.sendRefresh(RefreshTarget.CATCHUPS);
        this.refreshManager.sendRefresh(RefreshTarget.TRIM_PLAYER);
      },
      () => {
        this.loading = false;
      },
    );
  }

  //Delete content Permanently
  deleteContentPermanently(contentId: number): void {
    this.loading = true;
    try {
      this.contentService.deleteContentPermanently(contentId).subscribe((_) => {
        this.message();
      });
    } catch (error) {
      this.loading = true;
    }
  }
  // Set Content Status Deleted

  setContentStatusDeleted(contentId: number): void {
    this.loading = true;
    this.contentService.deleteContent(contentId).subscribe(
      (_) => {
        this.message();
      },
      (error) => {
        this.loading = true;
      },
    );
  }

  //Delete License
  deleteLicense(licenseId: number): void {
    try {
      this.licenseService.deleteLicense(licenseId).subscribe((_) => {
        this.message();
      });
    } catch (error) {
      this.loading = false;
    }
  }

  deleteCast(castId: number): void {
    this.castService.deleteCast(castId).subscribe((_) => {
      this.refreshManager.sendRefresh(RefreshTarget.CAST_MANAGEMENT);
      this.message();
    });
  }

  deleteMetadataLanguage(metadataLangId: number): void {
    this.metadatLanguageService.deleteContentLanguageMetadata(metadataLangId).subscribe((_) => {
      this.message();
    });
  }

  deleteCatchupPlanProfile(planProfileId: number): void {
    this.planningService.deletePlanProfileById(planProfileId).subscribe((response) => {
      this.showDeleteWarnings(response);
      this.message();
    });
  }

  private showDeleteWarnings(response: any): void {
    if (!response || !response.skippedItems || response.skippedItems.length === 0) {
      return;
    }

    const skippedText = response.skippedItems
      .map((item) => 'contentId=' + item.contentId + ', planProfileId=' + item.planProfileId + ', reason=' + item.reason)
      .join(' | ');
    this.alertService.warning('Some child plans could not be deleted: ' + skippedText, 'License mismatch');
  }

  deleteEncodingProfile(encodingProfileId: number): void {
    this.encodingProfileService.deleteEncodingProfile(encodingProfileId).subscribe((_) => {
      this.message();
    });
  }

  deleteMediaFile(contentId: number, contentMediaFileRequest: ContentMediaFilesRequest): void {
    this.contentService.removeMediaFile(contentId, contentMediaFileRequest).subscribe((_) => {
      this.message();
    });
  }

  deleteContentIssueType(contentIssueTypeId: number): void {
    this.contentIssueTypeService.deleteContentIssueType(contentIssueTypeId).subscribe((_) => {
      this.message();
    });
  }

  deleteFilterPreset(presetId: number): void {
    this.filterPresetDataService.deleteById(presetId).subscribe((response) => {
      this.message();
    });
  }

  deleteTrailerOfContent(contentId: number) {
    let operationRequest = new TrailerOperationRequest();
    operationRequest.userId = parseInt(localStorage.getItem('userID'));
    operationRequest.username = localStorage.getItem('username');
    this.contentService.setTrailerWaiting(contentId, false, operationRequest).subscribe((_) => {
      this.message();
    });
  }

  deletePackagePreset(packagePresetId: number): void {
    this.packagePresetService.deletePackagePreset(packagePresetId).subscribe(() => {
      this.refreshManager.sendRefresh(RefreshTarget.CATCHUPS);
      this.message();
    });
  }
  deleteTranscodePreset(transcodePresetId: number): void {
    this.transcodePresetsService.deleteTranscodePreset(transcodePresetId).subscribe(() => {
      this.refreshManager.sendRefresh(RefreshTarget.ENCODING_PROFILES);
      this.message();
    });
  }
  message(): void {
    this.timer = setTimeout(() => {
      this.loading = false;
      this.store.dispatch(new RefreshActions.RefreshState(true));
      this.utility.closeModal('alert-modal');
    }, 300);
  }

  PageReseter(): void {
    CatchupService.page = 1;
  }
}
